import {Routes as Switch, Route} from 'react-router-dom';
import HomePage from './modules/pages/Home';
import Login from './modules/pages/auth/login';
import Distributeurs from './modules/pages/parametres/Distributeurs';
import TerritoiresPage from './modules/pages/parametres/Territoires';
import ZonesPage from './modules/pages/parametres/Zones';
import SecteursPage from './modules/pages/parametres/Secteurs';
import AddDistributeurForms from './modules/pages/parametres/foms/add-distributeur';
import AddCommercialForms from './modules/pages/parametres/foms/add-commercial';
import OthersPage from './modules/pages/parametres/Others';
import Utilisateurs from './modules/pages/parametres/Utilisateurs';
import AddUserPage from './modules/pages/parametres/foms/add-user';
import RolePage from './modules/pages/parametres/Roles';
import AddRoleForm from './modules/pages/parametres/foms/add-role';
import EditRolePage from './modules/pages/parametres/foms/edit-role';
import Permissions from './modules/pages/parametres/Permissions';
import Commerciaux from './modules/pages/commerciaux/Commerciaux';
import Approvisionnement from './modules/pages/approvissionements/Approvisionnement';
import HomeStatsPage from './modules/pages/statistiques/Home_stats';
import EvdCommercialPage from './modules/pages/statistiques/evd_commerciaux';
import EvdPosPage from './modules/pages/statistiques/evd_pos';
import ApproCommercialPage from './modules/pages/statistiques/appro_commerciaux';
import MomoHomePage from './modules/pages/MomoHome';
import MomoCommercialPage from './modules/pages/statistiques/momo_commerciaux';
import FdrPage from './modules/pages/finances/FdrPage';
import FondRoulementSites from './modules/pages/finances/Fdr_sites';
import FondRoulementGeSitePage from './modules/pages/finances/Fdr_gesites';
import FondDeRoulementCommerciauxPage from './modules/pages/finances/Fdr_commerciaux';
import TransactionSoldeGesitePage from './modules/pages/finances/TransactionSoldeGesitePage';
import PerformancesPage from './modules/pages/finances/PerformancesPage';
import PerformanceEvd from './modules/pages/finances/PerformanceEvd';
import PerformanceMomo from './modules/pages/finances/PerformanceMomo';
import InventaireCaissePage from './modules/pages/finances/InventaireCaissePage';
import GroupePermissionPage from './modules/pages/parametres/GroupePermissionPage';
import AccesUserPage from './modules/pages/parametres/AceesUserPage';
import PageNotFound from './PageNotFound';
import TransactionAdvPage from './modules/pages/commerciaux/TransactionAdvPage';
import EcartGesites from './modules/pages/finances/EcartGesites';
import DegradationFondRoulementPage from './modules/pages/finances/suivi_degradation_fdr';

function Main(){
    return (
        <div>
            <Switch>
                <Route path='/' element={ <HomePage /> } />              
                <Route path='/momo' element={ <MomoHomePage /> } />              
                <Route path='/auth' element={ <Login /> } />               
                <Route path='/parametres/distributeurs' element={ <Distributeurs /> } />               
                <Route path='/parametres/zones' element={ <ZonesPage /> } />               
                <Route path='/parametres/territoires' element={ <TerritoiresPage /> } />               
                <Route path='/parametres/secteurs' element={ <SecteursPage /> } />               
                <Route path='/parametres/others' element={ <OthersPage /> } />               
                <Route path='/parametres/users' element={ <Utilisateurs /> } />               
                <Route path='/parametres/roles' element={ <RolePage /> } />               
                <Route path='/parametres/permissions' element={ <Permissions /> } />               
                <Route path='/parametres/add-distributeur' element={ <AddDistributeurForms /> } />               
                <Route path='/parametres/add-commercial' element={ <AddCommercialForms /> } />               
                <Route path='/parametres/add-user' element={ <AddUserPage /> } />               
                <Route path='/parametres/add-role' element={ <AddRoleForm /> } />               
                <Route path='/edit-role-page/:role_id' element={ <EditRolePage /> } />  

                <Route path='/commerciaux' element={ <Commerciaux /> } />               
                <Route path='/approvisionnements' element={ <Approvisionnement /> } />               
                <Route path='/home-stats' element={ <HomeStatsPage /> } />               
                <Route path='/evd-commerciaux' element={ <EvdCommercialPage /> } />               
                <Route path='/evd-pos' element={ <EvdPosPage /> } />               
                <Route path='/appro-commerciaux' element={ <ApproCommercialPage /> } />               
                <Route path='/momo-commerciaux' element={ <MomoCommercialPage /> } />


                <Route path='/finances-fdr' element={ <FdrPage /> } />               
                <Route path='/fonds-roulements-sites' element={ <FondRoulementSites /> } />               
                <Route path='/fonds-roulements-gesites' element={ <FondRoulementGeSitePage /> } />               
                <Route path='/fonds-roulements-commerciaux' element={ <FondDeRoulementCommerciauxPage /> } />  
                <Route path='/ecarts-list' element={ <EcartGesites /> } />              

                <Route path='/transactions-solde-gesites' element={ <TransactionSoldeGesitePage /> } />    
                <Route path='/degradation-fond-roulements' element={ <DegradationFondRoulementPage /> } />

                <Route path='/performances-pages' element={ <PerformancesPage /> } />    
                <Route path='/performances-evd' element={ <PerformanceEvd /> } />    
                <Route path='/performances-momo' element={ <PerformanceMomo /> } />    
                <Route path='/inventaire-caisses' element={ <InventaireCaissePage /> } /> 
                
                <Route path='/list-transaction-adv' element={ <TransactionAdvPage /> } /> 


                <Route path='/groups-permission' element={ <GroupePermissionPage /> } />    
                <Route path='/access-utilisateurs' element={ <AccesUserPage /> } />   


                <Route path='/page-no-found' element={ <PageNotFound /> } />    

            </Switch>
        </div>
    );
}

export default Main;